import { memo } from 'react'
import { Box } from '@/components/Layout'
import Text from '../Text'
import { PageContentProps } from './PageContent.types'
import { pageContentStyles as styles } from './PageContent.style'

function PageContent({ data: { title, content } }: PageContentProps) {
  if (!content) return null

  return (
    <Box sx={styles.wrapper}>
      {title && (
        <Text sx={styles.title} component={'h2'}>
          {title}
        </Text>
      )}
      <Box sx={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
    </Box>
  )
}

export default memo(PageContent)
